<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
  <div mat-dialog-title class="dialog-header">
    <h3 class="dialog-title">Add User</h3>
    <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
  </div>
  <form [formGroup]="form" (ngSubmit)="onCreate()">
    <mat-dialog-content>
      <mat-form-field>
        <mat-label>Name</mat-label>
        <input matInput autocomplete="off" type="text" formControlName="name" required />
        @if (form.get('name')?.hasError('required')) {
          <mat-error> Name Field is Required. </mat-error>
        }
        @if (!form.get('name')?.hasError('required') && form.get('name')?.hasError('whitespace')) {
          <mat-error>
            Name cannot contain leading/trailing whitespace
          </mat-error>
        }
        @if (form.get('name')?.hasError('maxlength')) {
          <mat-error>
            Name must be less than 255 characters
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>Email Address</mat-label>
        <input matInput autocomplete="off" type="text" formControlName="emailAddress" required />
        @if (form.get('emailAddress')?.hasError('required')) {
          <mat-error>
            Email Address Field is Required.
          </mat-error>
        }
        @if (form.get('emailAddress')?.hasError('pattern')) {
          <mat-error> Invalid Email Address </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>Username</mat-label>
        <input matInput autocomplete="off" type="text" formControlName="username" required />
        @if (form.get('username')?.hasError('required')) {
          <mat-error> Username Field is Required. </mat-error>
        }
        @if (!form.get('username')?.hasError('required') && form.get('username')?.hasError('whitespace')) {
          <mat-error
            >
            Username cannot contain leading/trailing whitespace
          </mat-error>
        }
        @if (form.get('username')?.hasError('maxlength')) {
          <mat-error>
            Username must be less than 255 characters
          </mat-error>
        }
      </mat-form-field>
      <!-- <mat-form-field *ngIf="fromAccount">
      <mat-label>Extension</mat-label>
      <input
        [lcsSingleSelect]="extensionSelect"
        [accountId]="accountId"
        ndtExtensionSelect
        type="text"
        formControlName="extension"
        [extensionTypesToExclude]="[7]"
        />
        <ndt-extension-select #extensionSelect></ndt-extension-select>
      </mat-form-field> -->
      @if (isAdminUser || isSystemUser) {
        <span
          ><mat-checkbox formControlName="isAdmin">Admin</mat-checkbox
          ><mat-icon
          class="tooltip"
               [appTooltip]="
                  'Creating a user as Admin will grant\n' +
                  ' any available privileges immediately,\n' +
                  ' and any new privilege will be \n' +
                  ' automatically granted for that user.'
               "
          >help</mat-icon
          ></span
          >
      }
      <br />
      @if (isSystemUser && !fromAccount) {
        <mat-checkbox formControlName="isSystemUser">System User</mat-checkbox>
      }
      @if (isSystemUser && !fromAccount) {
        <mat-form-field>
          <mat-label>Account</mat-label>
          <input
            autocomplete="off"
            type="text"
            [lcsSingleSelect]="accountSel"
            ndtAccountSelect
            formControlName="account"
            id="user-account"
            />
            <ndt-account-select #accountSel></ndt-account-select>
          </mat-form-field>
        }
      </mat-dialog-content>
      <mat-dialog-actions>
        <button type="submit" title="Create" mat-raised-button>Save</button>
      </mat-dialog-actions>
    </form>
  </lcs-loading-overlay>
